import { SortBy } from '../domain';
import {
	BarSeriesValue,
	sortCountryEntities,
	sortSeriesByName,
	sortSeriesByValue,
} from '~/MedicinalBrandsAnalytics/Region/reducer';
import { ErpStatsResponse } from 'com.cogvio.pricemonitor.api';
import { useState } from 'react';

export function useChartSort() {
	const [sortBy, setSortBy] = useState(SortBy.PRICE);

	const handleSortChange = () => {
		setSortBy(sortBy === SortBy.PRICE ? SortBy.NAME : SortBy.PRICE);
	};

	const sortSeries = (series: BarSeriesValue[]) =>
		series.sort(sortBy === SortBy.PRICE ? sortSeriesByValue : sortSeriesByName);

	const sortCategories = (series: BarSeriesValue[], stats: ErpStatsResponse) =>
		sortBy === SortBy.PRICE
			? [...series.reverse()].map((item) => item[0])
			: sortCountryEntities(stats.quadrants).map(({ country }) => country.alpha2);

	return { sortBy, handleSortChange, sortSeries, sortCategories };
}
